import { render, staticRenderFns } from "./searchLabelsV.vue?vue&type=template&id=089e5fe5&scoped=true&"
import script from "./searchLabelsV.vue?vue&type=script&lang=js&"
export * from "./searchLabelsV.vue?vue&type=script&lang=js&"
import style0 from "./searchLabelsV.vue?vue&type=style&index=0&id=089e5fe5&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e5fe5",
  null
  
)

export default component.exports